export default [
  {
    path: '/report-performance/customer-service',
    name: 'report-performance-customer-service',
    component: () => import('@/views/pages/komtim/talent/report-performance/Index.vue'),
    meta: {
      name: 'Report Performa Customer Service',
      resource: 'Komtim - Talent',
      action: 'manage',
    },
  },
  {
    path: '/report-performance/admin-marketplace',
    name: 'report-performance-admin-marketplace',
    component: () => import('@/views/pages/komtim/talent/report-performance/admin-marketplace/List.vue'),
    meta: {
      name: 'Report Performa Admin Marketplace',
      resource: 'Komtim - Talent',
      action: 'manage',
    },
  },
  {
    path: '/report-performance/admin-marketplace/:id',
    name: 'report-performance-admin-marketplace-detail',
    component: () => import('@/views/pages/komtim/talent/report-performance/admin-marketplace/Detail.vue'),
    meta: {
      name: 'Detail Report Performa Admin Marketplace',
      navActiveLink: 'report-performance-admin-marketplace',
      resource: 'Komtim - Talent',
      action: 'manage',
    },
  },
  {
    path: '/report-performance/admin-marketplace/:id/preview',
    name: 'report-performance-admin-marketplace-preview',
    component: () => import('@/views/pages/komtim/talent/report-performance/admin-marketplace/Sheet.vue'),
    meta: {
      name: 'Detail Report Performa Admin Marketplace',
      navActiveLink: 'report-performance-admin-marketplace',
      resource: 'Komtim - Talent',
      action: 'manage',
    },
  },
]
